import { render, staticRenderFns } from "./ReviewerTag.vue?vue&type=template&id=47693c60&scoped=true&"
import script from "./ReviewerTag.vue?vue&type=script&lang=js&"
export * from "./ReviewerTag.vue?vue&type=script&lang=js&"
import style0 from "./ReviewerTag.vue?vue&type=style&index=0&id=47693c60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47693c60",
  null
  
)

export default component.exports